module.exports = __webpack_public_path__ + "lv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/lv.svg
// module id = 926
// module chunks = 0